import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./SettingsPage.css";
import {
  getCurrentServiceFee,
  ServiceFee,
} from "../../services/serviceFeeService";
import UpdateServiceFeeModal from "../../compoonents/UpdateServiceFeeModal/UpdateServiceFeeModal";
import ComingSoonAction from "../../compoonents/ComingSoonAction/ComingSoonAction";
import feeIcon from "../../assets/images/purchaseicon.png";
import { FiUser, FiChevronRight } from "react-icons/fi";

const COMING_SOON_ITEMS = [
  "Manage page",
  "FAQs",
  "Manage Referrals",
  "About Us",
  "Footer",
  "Social links",
  "Testimonials",
  "Reviews & comments",
  "Policy & terms",
  "Contact Us",
];

const SettingsPage: React.FC = () => {
  const navigate = useNavigate();
  const [serviceFee, setServiceFee] = useState<ServiceFee | null>(null);
  const [loadingFee, setLoadingFee] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const fetchFee = async () => {
      setLoadingFee(true);
      try {
        const feeData = await getCurrentServiceFee();
        setServiceFee(feeData);
      } catch (err) {
        console.error("Could not load service fee data.", err);
      } finally {
        setLoadingFee(false);
      }
    };
    fetchFee();
  }, []);

  const handleUpdateSuccess = (updatedFee: ServiceFee) => {
    setServiceFee(updatedFee);
    setIsModalOpen(false);
  };

  return (
    <div className="settings-page">
      <h1 className="page-main-title">Settings</h1>

      <section className="settings-section">
        <h2 className="settings-section-title">Account</h2>
        <button
          type="button"
          className="settings-link-row"
          onClick={() => navigate("/profile-upload")}
        >
          <span className="settings-link-icon">
            <FiUser />
          </span>
          <span className="settings-link-text">
            <span className="settings-link-label">Profile picture</span>
            <span className="settings-link-hint">Upload or change your avatar</span>
          </span>
          <FiChevronRight className="settings-link-chevron" />
        </button>
      </section>

      <section className="settings-section">
        <h2 className="settings-section-title">Platform</h2>
        <div className="settings-grid settings-grid-single">
          <div className="settings-card card-live-data card-primary">
            <div className="card-header">
              <h3 className="card-title">Service Fee</h3>
            </div>
            <div className="card-content">
              {loadingFee ? (
                <p className="loading-text">Loading...</p>
              ) : serviceFee ? (
                <>
                  <p className="live-data-value">{serviceFee.percentage}%</p>
                  <button
                    type="button"
                    className="update-link"
                    onClick={() => setIsModalOpen(true)}
                  >
                    Update Fee
                  </button>
                </>
              ) : (
                <p className="error-text">Could not load fee.</p>
              )}
            </div>
            <div className="card-icon-wrapper">
              <img src={feeIcon} alt="" className="card-icon" aria-hidden />
            </div>
          </div>
        </div>
      </section>

      <section className="settings-section">
        <h2 className="settings-section-title">Site content</h2>
        <p className="settings-section-desc">
          These CMS sections are not connected to the admin API yet.
        </p>
        <ul className="settings-coming-soon-list">
          {COMING_SOON_ITEMS.map((label) => (
            <li key={label}>
              <ComingSoonAction title={`${label} — coming soon`}>
                <span className="settings-coming-soon-item">{label}</span>
              </ComingSoonAction>
            </li>
          ))}
        </ul>
      </section>

      {isModalOpen && serviceFee && (
        <UpdateServiceFeeModal
          currentPercentage={serviceFee.percentage}
          onClose={() => setIsModalOpen(false)}
          onSuccess={handleUpdateSuccess}
        />
      )}
    </div>
  );
};

export default SettingsPage;
